import styled from '@emotion/styled';
import TextField from '@mui/material/TextField';
import React, { useEffect, useState } from 'react';
import { Field, Form, Formik, FormikErrors } from 'formik';
import { useAlert } from '../../../shared/AlertProvider';
import { warrantService } from '../../../../api/services/warrant.service';
import { OrganizationRequestDto } from '../../../../api/services/dto/user-managment-dto/organization-request-dto';
import { UserDto } from '../../../../api/services/dto/user-managment-dto/user-dto';
import SelectOwner from '../assign-user-to-organization/cards/SelectOwner';

const regex = new RegExp('^[a-z_-]*$');
export const hasOnlyChars = (str: string) => regex.test(str);

interface OrganizationFormValues {
  id: string;
  name: string;
  owner: UserDto | null;
}

const emptyOwner: UserDto = { userId: '', email: '' };

export enum OrganizationErrorCodes {
  ORG_ID_REQUIRED = 'ORG_ID_REQUIRED',
  ORG_ID_INVALID_CHARS = 'ORG_ID_INVALID_CHARS',
  ORG_NAME_REQUIRED = 'ORG_NAME_REQUIRED',
  ORG_OWNER_REQUIRED = 'ORG_OWNER_REQUIRED',
}

export const getOrganizationErrorMessage = (code: OrganizationErrorCodes) => {
  switch (code) {
    case OrganizationErrorCodes.ORG_ID_REQUIRED:
      return 'Organization ID is required';
    case OrganizationErrorCodes.ORG_ID_INVALID_CHARS:
      return 'Organization ID can contain only lowercase, \'_\' and  \'-\' characters!';
    case OrganizationErrorCodes.ORG_NAME_REQUIRED:
      return 'Organization name is required';
    case OrganizationErrorCodes.ORG_OWNER_REQUIRED:
      return 'Organization owner is required';
    default:
      return 'Invalid input';
  }

};

export const validate = (values: OrganizationFormValues): FormikErrors<OrganizationFormValues> => {
  const errors: FormikErrors<OrganizationFormValues> = {};
  console.log(`Validate: ${JSON.stringify(values)}`);
  if (!values.id) {
    errors.id = OrganizationErrorCodes.ORG_ID_REQUIRED;
  }

  if (!hasOnlyChars(values.id)) {
    errors.id = OrganizationErrorCodes.ORG_ID_INVALID_CHARS;
  }

  if (!values.name) {
    errors.name = OrganizationErrorCodes.ORG_NAME_REQUIRED;
  }

  if (!values.owner || !values.owner.userId) {
    errors.owner = OrganizationErrorCodes.ORG_OWNER_REQUIRED as any;
  }

  return errors;
};
const OrganizationForm = () => {
  const { setAlert } = useAlert();
  const [org, setOrg] = useState<OrganizationFormValues>({
    id: '',
    name: '',
    owner: emptyOwner,
  });

  useEffect(() => {
    console.log(org);
  }, [org]);

  const createOrganization = async (values: OrganizationFormValues) => {
    const payload: OrganizationRequestDto = {
      id: values.id,
      name: values.name,
      owner: values.owner?.userId ?? '',
    };
    await warrantService
      .createOrganization(payload)
      .then(() => {
        setAlert({ open: true, title: 'Created the organization', severity: 'success' });
      })
      .catch((reason) => {
        console.error(`Failed to create organization: ${reason}`);
        setAlert({
          open: true,
          title: 'Failed to create organization',
          message: reason.message,
          severity: 'error' });
      });
    setOrg({
      id: '',
      name: '',
      owner: emptyOwner,
    });
  };

  return (
    <Formik
      initialValues={org}
      onSubmit={createOrganization}
      validate={validate}
      validateOnBlur={true}
      validateOnMount={true}
    >
      {() => (
        <Form id='create-organization-form'>

          <FieldsWrapper>
            <Field name='id' id='id' type='text'>
              {({ field, meta }: any) => (
                <TextField
                  {...field}
                  label='Organization ID'
                  error={meta.touched && !!meta.error}
                  helperText={meta.touched && !!meta.error ? getOrganizationErrorMessage(meta.error) : ' '}
                  className='buyer-pro-input'
                />
              )}
            </Field>

            <Field name='name' id='name' type='text'>
              {({ field, meta }: any) => (
                <TextField
                  {...field}
                  label='Organization Name'
                  error={meta.touched && !!meta.error}
                  helperText={meta.touched && !!meta.error ? getOrganizationErrorMessage(meta.error) : ' '}
                  className='buyer-pro-input'
                />
              )}
            </Field>

            <Field name='owner'>
              {({ field, meta, form }: any) => (
                <SelectOwner
                  selected={field.value || emptyOwner}
                  name='owner'
                  id='owner'
                  setCustomDirtyState={() => form.setFieldTouched('owner', true)}
                  helperText={meta.touched && !!meta.error}
                />
              )}
            </Field>
          </FieldsWrapper>
        </Form>
      )}
    </Formik>
  );
};

export default OrganizationForm;

const FieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;

`;
